import { OrderStatus } from '@/interfaces/paid-management';
import { PayChannel } from '@/interfaces/purchase';
import freeIcon from '../images/version/free.png';
import freeBadge from '../images/version/free-badge.svg';
import staterIcon from '../images/version/stater.png';
import staterBadge from '../images/version/stater-badge.svg';
import proIcon from '../images/version/pro.png';
import proBadge from '../images/version/pro-badge.svg';
import flagshipIcon from '../images/version/flagship.png';
import flagshipBadge from '../images/version/flagship-badge.svg';

export const getPayWay = (key?: PayChannel) => {
  switch (key) {
    case 'ALIPAY_UNDER_LINE_PAY':
      return '支付宝线上支付';
    case 'WECHAT_ONLINE_PAY':
      return '微信线上支付';
    case 'OFFLINE_WIRE_TRANSFER':
      return '线下对公转账';
    case 'ALIPAY_WIRE_TRANSFER':
      return '支付宝对公转账';
    case 'ALIPAY_ONLINE_PAY':
      return '支付宝在线支付';
    case 'NON_ACTUAL_RECEIPTS':
      return '其他支付方式'; //'非实际收款';
    case 'OTHER':
      return '其他';
    case 'ZERO_COST':
      return '零元购';
    default:
      return '';
  }
};

export const getPayStatus = (key?: OrderStatus) => {
  switch (key) {
    case OrderStatus.Canceled:
      return '已取消';
    case OrderStatus.Confirmed:
      return '已确认';
    case OrderStatus.Created:
      return '已创建';
    case OrderStatus.Finished:
      return '已完成';
    case OrderStatus.PayFail:
      return '支付失败';
    case OrderStatus.PaySuccessful:
      return '支付成功';
    case OrderStatus.WaitingConfirm:
      return '待确认';
    case OrderStatus.WaitingPayment:
      return '等待支付';
  }
};

export const toAliPayment = (data: string) => {
  const div = document.createElement('divform');
  div.innerHTML = data;
  document.body.appendChild(div);
  const len = document.forms.length - 1;
  document.forms[len].setAttribute('target', '_blank');
  document.forms[len].submit();
  document.body.removeChild(div);
};

export const PLAN_PACKAGE_CONFIG = {
  spec_code_100: {
    name: '免费版',
    description: '',
    color: 'text-[#ECECEC]',
    bgColor: 'bg-[#ECECEC]',
    icon: freeIcon,
    badge: freeBadge,
    alphaColor: '',
    deepColor: '',
  },
  spec_code_300: {
    name: '入门版',
    description: '适合初创企业与小型团队',
    color: 'text-[#BAD5EC]',
    bgColor: 'bg-[#BAD5EC]',
    icon: staterIcon,
    badge: staterBadge,
    alphaColor: '#CBE1F6',
    deepColor: '#4C5867',
  },
  spec_code_400: {
    name: '专业版',
    description: '适合成长型企业和专业团队，可按需自由扩容',
    color: 'text-[#FBD6EA]',
    bgColor: 'bg-[#FBD6EA]',
    icon: proIcon,
    badge: proBadge,
    alphaColor: '#F5D8F3',
    deepColor: '#A3125F',
  },
  spec_code_500: {
    name: '旗舰版',
    description: '无需担忧限额，随心自由使用，适合中大型企业',
    color: 'text-[#FFDE93]',
    bgColor: 'bg-[#FFDE93]',
    icon: flagshipIcon,
    badge: flagshipBadge,
    alphaColor: '#F4E2AB',
    deepColor: '#935E00',
  },
} as const;
